import React, { useState } from 'react'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'
import backgroundImage from '../../assets/fond_site.png'
// import bannerImg from '../../assets/banner.png'
import Footer from './Footer'


function MainLayout() {
  const [searchValue, setSearchValue] = useState('')
  const clearSearch = () => {
    setSearchValue('');
  };
  return (
    <div style={{fontFamily:'sans-serif'}}>
      {/* <img src={bannerImg} style={{width:"100%"}}/> */}
      <Navbar searchValue={searchValue} onChangeSearchValue={(valeur) => {
        setSearchValue(valeur)
      }} />
      <div style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: 'center', /* Center the image */
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '90vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // marginTop: '65px',
        zIndex:1
      }}>
        <Outlet context={{ searchValue, clearSearch }} />
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  )
}

export default MainLayout